<template>
  <div class="position-relative">
    <div>
      <div class="overall-bg">
        <b-container>
          <b-row>
            <b-col>
              <BackBtn :goback="$router.back" />
              <Headerlayout :headertext="dataId
                ? $t(
                  'ItemCategory.LinkNewCategoryandItemtostore.EditFormHeader'
                )
                : $t(
                  'ItemCategory.LinkNewCategoryandItemtostore.FormHeader'
                )
                " :contenttext="$t(
                  'ItemCategory.LinkNewCategoryandItemtostore.FormHeaderContent'
                )
                  ">
              </Headerlayout>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="form-white-bg">
        <b-container>
          <b-row>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <!-- <CustomDropdown :label="$t('5007.storename')" id="storename" name="storename"
                  :rules="{ required: true }" :required-icon="true" :items="Storenamelist" v-model="mapformdata.StoreId"
                  @update:modelValue="() => {
                getitemcategory(mapformdata.StoreId);
              }
                " /> -->
                <!-- {{ ModelStoreId }} -->
                <!-- <StoreDropDown :label="$t('5007.storename')" id="storename" name="storename" :rules="{ required: true }"
                  :required-icon="true" :items="Storenamelist" v-model="ModelStoreId" @update:modelValue="() => {
                    SelectStore(ModelStoreId);
                    getitemcategory(mapformdata.StoreId);
                  }
                    " /> -->

                <StoreDropDown label="Store" name="Store" id="Store" v-model="ModelStoreId" :storetype="0"
                  :filterId="Number(0)" :rules="{ required: true }" :disabled="storedisabled" :required-icon="true"
                  @update:modelValue="handleStoreChange" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomMultiSelect id="Item category" name="Item category" :label="$t('5007.category')"
                  :rules="{ required: true }" :required-icon="true" :items="Categoryoption"
                  v-model="mapformdata.ItemCategoryId" @update:modelValue="
                    () => {
                      getitem();
                    }
                  " />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container>
        <b-row class="mt-5">
          <b-row>
            <b-col class="d-flex flex-row-reverse">
              <div class="field">
                <TextField v-model="searchdata" name="" @keyup="filterlist(searchdata)" placeholder="Search Item">
                </TextField>
              </div>
            </b-col>
          </b-row>
          <div class="itemstoretbl">
            <SkeletonTableLoader :columns="headers" :loading="loading" v-if="loading" />
            <ETableview v-else :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
              :globalFilterFields="globalFilterFields" :data="List" :selectionMode="true"
              v-model:selection="selectedProduct" @selection="selectedProductItem" :seriaNlumber="true"
              :paginator="true" scrollHeight="500px">
              <template v-slot:Room="{ data }">
                <div class="label-d-none tablefield mb-0" @click="FilterRoom(data, 'N')">
                  <CustomDropdown :items="data.Roomoption" v-model="data.RoomId" @update:modelValue="">
                  </CustomDropdown>
                </div>
              </template>
              <template v-slot:Rack="{ data }">
                <div class="label-d-none tablefield mb-0" @click="FilterRack(data, 'N')">
                  <CustomDropdown :items="data.Rackoption" v-model="data.RackId" @update:modelValue="">
                  </CustomDropdown>
                </div>
              </template>
              <template v-slot:Row="{ data }">
                <div class="label-d-none tablefield mb-0" @click="FilterRow(data, 'N')">
                  <CustomDropdown :items="data.Rowoption" v-model="data.RowId" @update:modelValue="">
                  </CustomDropdown>
                </div>
              </template>
              <template v-slot:Box="{ data }">
                <div class="label-d-none tablefield mb-0" @click="FilterBox(data, 'N')">
                  <CustomDropdown :items="data.Boxoption" v-model="data.BoxId">
                  </CustomDropdown>
                </div>
              </template>
              <template v-slot:Reorderlevel="{ data }">
                <div class="label-d-none tablefield mb-0">
                  <TextField v-model="data.ReOrderLevel" name=""> </TextField>
                </div>
              </template>
              <template v-slot:MinReOrderLevel="{ data }">
                <div class="label-d-none tablefield mb-0">
                  <TextField v-model="data.MinReOrderLevel" name="">
                  </TextField>
                </div>
              </template>
            </ETableview>
          </div>
        </b-row>
        <b-row>
          <Footer :cancelhide="false" @save="IsSubmit" :label="label" :loading="Saveloader" />
        </b-row>
      </b-container>
    </div>

    <!-- Removed duplicate loader since we're using SkeletonTableLoader -->
    <div>
      <Toast />
      <!-- <createdsuccessfully :visible="successpop" @ok="closetrigger()" /> -->
      <createdsuccessfully :visible="visible" @ok="closetrigger()" />
      <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { debounce, update } from 'lodash';
import ETableview from "../../../../../../components/FormComponents/EditableTable.vue";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";

import BackBtn from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import Storeservice from "../../../../Service/StoreService";
import ItemCategoryservice from "../../../../Service/CategoryService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import InputNumber from "../../../../../../components/FormComponents/InputNumber.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import RackService from "../../../../../../modules/Inventory/Service/RackService";
import RowService from "../../../../../../modules/Inventory/Service/RowService";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import ItemCategoryMappingService from "../../../../../../modules/Inventory/Service/ItemCategoryMappingService";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import ItemConfigurationService from "../../../../../../modules/Inventory/Service/ItemConfiguration";
import ItemService from "../../../../../../modules/Inventory/Service/ItemMasService";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    InputNumber,
    Tableview,
    BackBtn,
    Headerlayout,
    Footer,
    CustomDropdown,
    TextField,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    createdsuccessfully,
    UpdatedSuccessfully,
    ItemCategoryMappingService,
    Loader,
    ETableview,
    CustomMultiSelect,
    StoreDropDown,
    SkeletonTableLoader,
  },

  setup() {
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");
    let Entitysession: any = localStorage.getItem("EntityData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = session.BranchId;
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let EntityId = Number(Entitysession.EntityId);
    const Storenamelist = ref();
    const Categoryoption = ref();
    const Itemoption = ref();
    const Rackoption = ref();
    const Roomoption = ref();
    const Rowoption = ref();
    const Boxoption = ref();
    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const visible = ref(false);
    const { t } = useI18n();
    let loading1 = ref(false);
    const rowFocus = ref(false);
    const dataEdit = ref();
    let loading = ref(false);
    let storestatus = ref(false);
    let Ids = ref();
    let Idsdata = ref("");
    const selectedProduct: any = ref([]);
    let searchdata = ref();
    const routes = useRoute();
    let dataId = routes.query.StoreId;
    let tabledata: any = ref([]);
    let copyItemList: any = ref([]);
    const items = ref([]);
    let List: any = ref([]);
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const routers = useRouter();
    const router = useRoute();
    let storedisabled = ref(false);
    const label = ref(t("btn.save"));

    const storeid = router.query.StoreId;
    const categoryid = ref();
    let categoryarray: any = ref([]);
    let categorList = ref();
    let strid = 0;
    const deletepop = ref(false);
    const Deletemodel = ref(false);
    let obj = ref({});
    let ModelStoreId: any = ref();
    const toast = useToast();
    let Saveloader = ref(false);
    let StoreBranchId = router.query.BranchId ? router.query.BranchId : 0;

    let mapformdata = ref({
      // IsNew: true,
      // IsModified: true,
      // IsActive: true,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      StoreId: ref(),
      ItemCategoryId: ref(),
      ItemId: ref(),
      RoomId: ref(),
      RackId: ref(),
      RowId: ref(),
      BoxId: ref(),
      ReOrderLevel: "",
      EntityId: 0,
      StoreBranchMapId: 0,
    });

    const ItemTableDropDown: any = ref({
      ItemBrandoption: [],
      ItemModelNumberoption: [],
      ItemSizeoption: [],
      Roomoption: [],
      Rackoption: [],
      Rowoption: [],
      Boxoption: [],
    });

    const headers = [
      {
        header: "Category",
        field: "ItemCategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
      },
      {
        header: "Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Brand",
        field: "BrandName",
        class: "mediumwidth",
      },
      {
        header: "Model",
        field: "ModelNumberName",
        class: "mediumwidth",
      },
      {
        header: "Size",
        field: "SizeName",
        class: "mediumwidth",
      },
      {
        header: "Room",
        slot: "Room",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: "Rack",
        slot: "Rack",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: "Row",
        slot: "Row",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: "Box",
        slot: "Box",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: "Min Reorder",
        slot: "MinReOrderLevel",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Max Reorder",
        slot: "Reorderlevel",
        fieldDisplay: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };

    const globalFilterFields = ref(headers.map((col) => col.field));

    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    async function ReadyFunction() {
      debugger;
      await GetItemConfigurationwise();
      if (storeid) {
        storedisabled.value = true;
        label.value = t("btn.update");
        await IsShow();
        await getitem();
      }
    }

    // get store
    // async function getstore() {
    //   debugger;
    //   try {
    //     const dataresponse = await Storeservice.getStoreList(
    //       HospitalId,
    //       BranchId
    //     );
    //     Storenamelist.value = dataresponse["result"]
    //       .filter(
    //         (items) =>
    //           items.HospitalId == HospitalId && items.BranchId == BranchId
    //       )
    //       .map((item: any) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    // get item
    let ItemConfigurationwise: any = ref([]);

    async function GetItemConfigurationwise() {
      try {
        const dataresponse = await ItemService.GetItemConfigurationwise();
        console.log(dataresponse);
        debugger;

        ItemConfigurationwise.value = dataresponse["result"];
      } catch (error) {
        console.log(error);
      }
    }

    // get item
    async function getitem() {
      debugger;
      if (!loading.value) loading.value = true;
      try {
        if (mapformdata.value.ItemCategoryId) {
          const filteredItems = ItemConfigurationwise.value.filter((item) =>
            mapformdata.value.ItemCategoryId.includes(item.ItemCategoryId)
          );

          List.value = filteredItems.map((item: any) => ({
            ...item,
            name: item.ItemName,
            value: item.Id,
            StoreName: ModelStoreId.value.Name,
            StoreId: mapformdata.value.StoreId,
          }));

          copyItemList.value = [...List.value];

          if (List.value.length > 0) {
            await getitembycategory();
          }
        }
      } catch (error) {
        console.error(error);
        toast.add({
          severity: "error",
          summary: "Error loading items",
          detail: (error as any).message,
          life: 3000,
        });
      } finally {
        loading.value = false;
      }
    }

    //TableView
    async function IsShow() {
      debugger;
      try {
        if (storeid && StoreBranchId) {
          const response = await ItemStoreMappingService.List(
            storeid,
            StoreBranchId
          );

          if (response["result"].length > 0) {
            ModelStoreId.value = response["result"][0]["StoreBranchMapId"];
            mapformdata.value.StoreId = response["result"][0]["StoreId"];
            mapformdata.value.StoreBranchMapId =
              response["result"][0]["StoreBranchMapId"];

            await loadselectedstore();
            getitemcategory(mapformdata.value.StoreId);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    // Get item category
    async function getitemcategory(data) {
      debugger;
      try {
        if (data && StoreBranchId) {
          const dataresponse =
            await ItemStoreMappingService.StoreCategoryMappingget(
              data,
              StoreBranchId
            );
          Categoryoption.value = dataresponse["result"].map((item: any) => {
            item.name = item.CategoryName;
            item.value = item.CategoryId;
            return item;
          });
          if (dataresponse["result"].length == 0) {
            resetField("Item category");
            List.value = [];
            selectedProduct.value = [];
            toast.add({
              severity: "warn",
              summary: "selected store is not mapped with any category",
              detail: "",
              life: 3000,
            });
          }

          await GetRoomByStoreId();
          await GetRackByStoreId();
          await GetRowByStoreId();
          await GetBoxByStoreId();
          loadselectedstore();
        }
      } catch (error) {
        console.log(error);
      }
    }

    function SelectStore(value) {
      debugger;
      if (value) {
        mapformdata.value.StoreId = value.Id;
        mapformdata.value.StoreBranchMapId = value.StoreBranchMapId;
        StoreBranchId = value.BranchId;
      }
      mapformdata.value.ItemCategoryId = ref();
    }

    async function handleStoreChange() {
      // First call SelectStore
      await SelectStore(ModelStoreId.value);
      // Then call getitemcategory with the updated StoreId
      getitemcategory(mapformdata.value.StoreId);
    }

    interface MappingData {
      ItemStoreMappingId: number;
      MinReOrderLevel: number;
      RackId: number;
      RoomId: number;
      BoxId: number;
      RowId: number;
      ReOrderLevel: number;
      ItemId: number;
      Brand: string;
      ModelNumber: string;
      Size: string;
    }

    async function getitembycategory() {
      loading.value = true;
      try {
        const dataresponse = await ItemCategoryMappingService.getItemListdata(
          mapformdata.value.StoreId,
          categorList.value
            ? categorList.value
            : mapformdata.value.ItemCategoryId.toString()
        );

        // Create a map for faster lookups
        if (dataresponse["result"].length > 0) {
          const responseMap = new Map<string, MappingData>();
          dataresponse["result"].forEach((item: MappingData) => {
            const key = `${item.ItemId}-${item.Brand}-${item.ModelNumber}-${item.Size}`;
            responseMap.set(key, item);
          });

          const matchedItems = List.value.filter((l) => {
            const key = `${l.Id}-${l.Brand}-${l.ModelNumber}-${l.Size}`;
            return responseMap.has(key);
          });

          // Update matched items with their mapping data
          matchedItems.forEach((item) => {
            const key = `${item.Id}-${item.Brand}-${item.ModelNumber}-${item.Size}`;
            const mappingData = responseMap.get(key);

            if (mappingData) {
              item.ItemStoreMappingId = mappingData.ItemStoreMappingId;
              item.MinReOrderLevel = mappingData.MinReOrderLevel;
              item.RackId = mappingData.RackId === 0 ? null : mappingData.RackId;
              item.RoomId = mappingData.RoomId === 0 ? null : mappingData.RoomId;
              item.BoxId = mappingData.BoxId === 0 ? null : mappingData.BoxId;
              item.RowId = mappingData.RowId === 0 ? null : mappingData.RowId;
              item.ReOrderLevel = mappingData.ReOrderLevel;
            }
          });

          selectedProduct.value = matchedItems;

          // Apply filters
          for (const item of selectedProduct.value) {
            await FilterRoom(item, "E");
            await FilterRack(item, "E");
            await FilterRow(item, "E");
            await FilterBox(item, "E");
          }
        }
      } catch (error) {
        console.error(error);
        toast.add({
          severity: "error",
          summary: "Error loading items",
          detail: (error as any).message,
          life: 3000,
        });
      } finally {
        loading.value = false;
      }
    }

    async function loadselectedstore() {
      let response1 = await ItemStoreMappingService.multistorecatlist(
        HospitalId,
        BranchId
      );

      categoryid.value = response1["result"].filter(
        (i) => i.StoreId === mapformdata.value.StoreId
      );

      categorList.value = categoryid.value[0].CategoryId;
      categoryarray.value = categoryid.value[0].CategoryId.split(",");
      categoryarray.value = categoryarray.value.map((item) => Number(item));

      mapformdata.value.ItemCategoryId = categoryarray.value;
      await getitem();
    }

    async function GetRoomByStoreId() {
      try {
        debugger;
        if (mapformdata.value.StoreId) {
          const dataresponse = await ItemStoreMappingService.getroommaster(
            mapformdata.value.StoreId
          );
          ItemTableDropDown.value.Roomoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function GetRackByStoreId() {
      debugger;
      try {
        if (mapformdata.value.StoreId) {
          const dataresponse = await RackService.getRackByStoreId(
            mapformdata.value.StoreId
          );

          ItemTableDropDown.value.Rackoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function GetRowByStoreId() {
      try {
        if (mapformdata.value.StoreId) {
          const dataresponse = await ItemStoreMappingService.GetRowByStoreId(
            mapformdata.value.StoreId
          );

          ItemTableDropDown.value.Rowoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function GetBoxByStoreId() {
      try {
        if (mapformdata.value.StoreId) {
          const dataresponse = await ItemStoreMappingService.GetBoxByStoreId(
            mapformdata.value.StoreId
          );
          ItemTableDropDown.value.Boxoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.BoxName;
              item.value = item.Id;
              return item;
            }
          );
        }

      } catch (error) {
        console.log(error);
      }
    }

    async function FilterRoom(data, Type) {
      debugger;

      data.Roomoption = ItemTableDropDown.value.Roomoption;

      if (data.Roomoption.length == 0) {
        data.Roomoption = ItemTableDropDown.value.Roomoption;
      }

      if (Type == "N") {
        data.Rackoption = [];
        data.RackId = null;
        data.Rowoption = [];
        data.RowId = null;
        data.Boxoption = [];
        data.BoxId = null;
      }
    }

    async function FilterRack(data, Type) {
      debugger;

      if (data.RoomId != null) {
        data.Rackoption = ItemTableDropDown.value.Rackoption.filter(
          (x) => x.RoomId == data.RoomId
        );

        if (data.Rackoption.length == 0) {
          data.Rackoption = ItemTableDropDown.value.Rackoption;
        }

        if (Type == "N") {
          data.Rowoption = [];
          data.RowId = null;
          data.Boxoption = [];
          data.BoxId = null;
        }
      }
    }

    async function FilterRow(data, Type) {
      debugger;

      if (data.RoomId != null && data.RackId != null) {
        data.Rowoption = ItemTableDropDown.value.Rowoption.filter(
          (x) => x.RoomId == data.RoomId && x.RackId == data.RackId
        );

        if (data.Rowoption.length == 0) {
          data.Rowoption = ItemTableDropDown.value.Rowoption;
        }

        if (Type == "N") {
          data.Boxoption = [];
          data.BoxId = null;
        }
      }
    }

    async function FilterBox(data, Type) {
      debugger;
      if (data.RoomId != null && data.RackId != null && data.RowId != null) {
        data.Boxoption = ItemTableDropDown.value.Boxoption.filter(
          (x) =>
            x.RoomId == data.RoomId &&
            x.RackId == data.RackId &&
            x.RowId == data.RowId
        );

        if (data.Boxoption.length == 0) {
          data.Boxoption = ItemTableDropDown.value.Boxoption;
        }
      }
    }

    function closetrigger() {
      visible.value = false;
      updatepop.value = false;
      successpop.value = false;
      // routers.back();
      setupHistoryManagement(routers, 2);
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    const filterlist = debounce((data) => {
      loading.value = true;
      try {
        List.value = copyItemList.value.filter((item) =>
          item.ItemName.toLowerCase().includes(data.toLowerCase())
        );
      } finally {
        loading.value = false;
      }
    }, 300);

    function selectedProductItem(data) {
      debugger;
      selectedProduct.value = data;
    }

    // const IsSubmit = handleSubmit(async (values) => {

    const IsSubmit = async () => {
      debugger;
      Saveloader.value = true;
      try {
        let itemCategoryarray: any = ref([]);
        debugger;
        if (selectedProduct.value.length > 0) {
          for (let i = 0; i < selectedProduct.value.length; i++) {
            let obj = {};
            const ObjValue = selectedProduct.value[i];
            let mapobj: any = {};

            obj["Id"] = ObjValue.ItemStoreMappingId;

            obj["StoreId"] = ObjValue.StoreId || 0;
            obj["ItemCategoryId"] = ObjValue.ItemCategoryId || 0;
            obj["ItemId"] = ObjValue.Id || 0;
            obj["RoomId"] = ObjValue.RoomId || 0;
            obj["RackId"] = ObjValue.RackId || 0;
            obj["RowId"] = ObjValue.RowId || 0;
            obj["BoxId"] = ObjValue.BoxId || 0;
            obj["ReOrderLevel"] = ObjValue.ReOrderLevel || 0;

            obj["ModifiedBy"] = UserId;
            obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            obj["CreatedBy"] = UserId;
            obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            obj["HospitalId"] = HospitalId;
            obj["BranchId"] = StoreBranchId;
            obj["EntityId"] = EntityId || 0;

            obj["StoreBranchMapId"] = ModelStoreId.value.StoreBranchMapId || ModelStoreId.value || 0;

            obj["MinReOrderLevel"] = ObjValue.MinReOrderLevel || 0;
            obj["Brand"] = ObjValue.Brand || 0;
            obj["ModelNumber"] = ObjValue.ModelNumber || 0;
            obj["Size"] = ObjValue.Size || 0;

            itemCategoryarray.value.push(obj);
          }

          let result = await ItemStoreMappingService.Ismulticreate(
            itemCategoryarray.value
          );

          let msg = result["ErrorInfo"].ErrorCode;
          if (msg == null) {
            if (label.value == "Update") {
              updatepop.value = true;
            }
            else {
              successpop.value = true;
              //visible.value = true;

            }

            Saveloader.value = false;
          } else {
            console.log(result["ErrorInfo"].ErrorCode);
            Saveloader.value = false;
          }
        } else {
          alert("Select the Items");
          Saveloader.value = false;
        }
      } catch (error) {
        // loading.value = false;
        Saveloader.value = false;
      }
    };
    return {
      storedisabled,

      selectedProductItem,
      Idsdata,
      Storenamelist,
      Categoryoption,
      Itemoption,
      Roomoption,
      Rackoption,
      Rowoption,
      Boxoption,
      mapformdata,
      Ids,
      deletepop,
      alreadyclosetrigger,
      IsSubmit,
      // getstore,
      getitemcategory,
      getitem,
      GetRoomByStoreId,
      GetRackByStoreId,
      GetRowByStoreId,
      GetBoxByStoreId,
      IsShow,
      // IsEdit,
      closetrigger,
      headers,
      filters,
      globalFilterFields,
      loading1,
      List,
      Deletemodel,
      Editmodel,
      successpop,
      // getitembycatid,
      storestatus,
      loading,
      selectedProduct,
      filterlist,
      searchdata,
      dataId,
      SelectStore,
      ModelStoreId,
      handleStoreChange,

      FilterRoom,
      FilterRack,
      FilterRow,
      FilterBox,
      $t: t, // Expose translation function
      $router: useRouter(),
      Saveloader,
      label,
      visible,
      updatepop
    };
  },
});
</script>
